import React, { FC } from "react";

interface Props {
  readonly fillColor: string;
  readonly strokeColor: string;
}

export const BoxIcon: FC<Props> = ({ fillColor, strokeColor }) => {
  return (
    <svg
      className="box"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <rect
        width="24"
        height="24"
        x="3"
        y="3"
        stroke={strokeColor}
        strokeWidth="2"
        fill={fillColor}
      />
    </svg>
  );
};
